import type { Router } from '@remix-run/router';
import type { Edition } from './auth/passwordSession';
import { buildCommunityRouter } from './community/router';
import { enterpriseRouter } from './enterprise/router';

/**
 * One bundle, two shells.
 *
 * The enterprise shell is the worklist product: patient-centric, PHI on
 * screen, FHIR-driven metadata. The community shell is the image-sharing
 * product: collections, groups, studies, public browsing, no patient
 * anywhere. They share the viewer, the engines, annotations, the upload
 * transport and the auth gate (everything outside `enterprise/` and
 * `community/`), and nothing else.
 *
 * Which shell mounts is decided by the SERVER (GET /auth/config), not by a
 * build flag, so the same image serves both editions and a deployment can
 * never ship the wrong shell for its data.
 */
export function routerFor(edition: Edition): Router {
  return edition === 'community' ? buildCommunityRouter() : enterpriseRouter;
}
